import MessagingContainer from "./MessagingContainer";

export default MessagingContainer;
